import {Injectable} from "@angular/core";
import * as uuid from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class RaygunStateService {

  private _useRaygun = false;

  private _anonymousId: string = null;
  
  public get useRaygun() {
    return this._useRaygun;
  }
  
  public set useRaygun(val) { 
    this._useRaygun = val;
  }

  constructor() {
    
  }
  
  public get anonymousId() {
    if (!this._anonymousId) {
      this._anonymousId = uuid.v4()
    }
    
    return this._anonymousId;
  }
  
  public clearAnonymousId() {
    this._anonymousId = null;
  }
  
}
